import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./../style.css";
import "./linkeddomainstyle.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { color } from "d3-color";
import LiquidFillGauge from "react-liquid-gauge";
import { interpolateRgb } from "d3-interpolate";
import { useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import CommonAlert, { GetuserDatavalue } from "../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Loader from "../CommonLoader";
import { Container, Grid, Box, Typography } from '@mui/material';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import WarningCount from "../Asset/esocardicon/SchemaDetail/WarningCount.svg";
import ErrorCount from "../Asset/esocardicon/SchemaDetail/ErrorCount.svg";
import Chart from "react-apexcharts";
import Commoncard from "../Commoncard";



export default function LinkedDomainList(props) {

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    "domain_authority_avg": 0,
    "importance_score": 0,
    "da_quality_distribution": {},
    "referring_domain_growth": [],
    "top_5_most_influential": []
  });
  const navigate = useNavigate();


  const apihandleClose = () => {
    setapiOpen(false);
  };


  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    callUserdataApi();
  }, []);


  const columns = [
    {
      field: "domain_name",
      headerName: "Domain Name",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: 'Name provided for the domain.',
    },
    // {
    //   field: "da",
    //   headerName: "DA",
    //   minWidth: 80,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   description: 'Domain InLink Rank (Domain Authority) of the referring domain.',
    // },
    {
      field: "da",
      headerName: "DA",
      minWidth: 100,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Domain InLink Rank (Domain Authority) of the referring domain.",
      renderCell: (cardData) => {
        var sr = cardData.row.da;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: '#0b2033',
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
          />
        );
      },
    },
    {
      field: "total_backlinks_percentage",
      headerName: "Total Backlink(from this domain)",
      minWidth: 300,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: 'The total number of backlinks pointing to the target from this domain.',
      renderCell: (cardData) => {
        var datawidth = cardData.row.total_backlinks_percentage;
        var percentdata = datawidth + "%";
        return (
          <div className=" dt-left" id="td-backlink-0" data-sort={1}><span>{cardData.row.total_backlinks}</span>
            <div className="stacked-bar-graph">
              <span style={{ width: percentdata }} className="bardata" />
            </div>
            <span style={{ textAlign: 'left' }}>{percentdata}</span>
          </div>
        );
      },
    },
    {
      field: "do_follow_backlinks_percentage",
      headerName: "Do Follow Backlinks",
      minWidth: 300,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: 'The number of backlinks from this domain that are not marked as nofollow.',
      renderCell: (cardData) => {
        var datawidth = cardData.row.do_follow_backlinks_percentage;
        var percentdata = datawidth + "%";
        return (
          <div className=" dt-left" id="td-backlink-0" data-sort={1}><span>{cardData.row.do_follow_backlinks}</span>
            <div className="stacked-bar-graphs">
              <span style={{ width: percentdata }} className="bardata" />
            </div>
            <span style={{ textAlign: 'left' }}>{percentdata}</span>
          </div>
        );
      },
    },
    {
      field: "first_seen",
      headerName: "First Seen",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      description: 'The date when the backlink was discovered and added to the index.',
    },
  ];

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "") => {
    var JobId = '';
    if (props.RankJob) {
      if (props.RankJob.value) {
        JobId = props.RankJob.value
      }
    }
    setLoading(true);
    setTableLoading(true);
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}backlinks/v2/linked_domain_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}`, {
      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
        navigate('/errorpages')
      }
    });

    const dataval = datavalue?.data?.linked_domain_table_data;
    if (dataval) {
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);
      SetAutoheightval(false)
    }
    else {
      setCardData("");
      SetAutoheightval(true)
    }
    if (datavalue?.data) {
      setSummaryData({
        "domain_authority_avg": datavalue?.data?.charts?.domain_authority_avg || 0,
        "importance_score": datavalue?.data?.charts?.importance_score || 0,
        "da_quality_distribution": datavalue?.data?.charts?.da_quality_distribution || {},
        "referring_domain_growth": datavalue?.data?.charts?.referring_domain_growth || [],
        "top_5_most_influential": datavalue?.data?.charts?.top_5_most_influential || []
      })
    }
    props.setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
    setTableLoading(false);
    setLoading(false);
  };

  useEffect(() => {
    if (props.FilterButtonTriggered === true) {
      callUserdataApi()
      props.SetFilterButtonTriggered(false)
      props.closeModal()
    }

  }, [props])

  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];

  const handleModelPopUp = () => {
    props.openModal();
  }

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }

  const cardDatas = [
    {
      value: summaryData.domain_authority_avg || 0,
      title: "Domain Authority Average",
      // badge: "SEO",
      iconSrc: ErrorCount,
      iconColor: 1,
      bgColor: 1,
    },
    {
      value: summaryData.importance_score || 0,
      title: "Importance Score",
      // badge: "TRAFFIC",
      iconSrc: WarningCount,
      iconColor: 2,
      bgColor: 2,
    }
  ];

  return (
    <div >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Backlinks Linked Domain List</title>
      </Helmet>
      {loading === true ? <Loader /> : null}

      <Container maxWidth={false} className="dashboard-container">
        <Grid container spacing={2} style={{ marginBottom: '20px' }}>

          <Grid container spacing={3} xs={12} sm={12} md={5} justifyContent="center">
            {cardDatas.map((item, index) => (
              <Grid item xs={12} sm={6} md={12} key={item.id}>
                <Commoncard
                  item={item}
                  nonclikable={true}
                />
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} md={7}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '270px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Referring Domain Growth</Typography>
              <Chart
                type="area"
                height={250}
                series={[
                  {
                    name: "Count",
                    // data: [4, 5, 6, 6, 77]
                    data: summaryData.referring_domain_growth.map(i => i.count)
                  }
                ]}
                options={{
                  chart: {
                    toolbar: { show: false }
                  },
                  colors: ["#ff601f"],
                  stroke: { curve: 'smooth', width: 3 },
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shadeIntensity: 1,
                      opacityFrom: 0.4,
                      opacityTo: 0.1
                    }
                  },
                  xaxis: {
                    // categories: ['Apr 12', 'Apr 13', 'Apr 14', 'Apr 15', 'Apr 16'],
                    categories: summaryData.referring_domain_growth.map(i =>
                      new Date(i.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' })
                    ),
                    tickPlacement: 'on', // 🔥 important
                    labels: {
                      offsetX: 50 // 👈 manual adjustment
                    }
                  },
                  yaxis: {
                    min: 0,
                    max: function (max) {
                      return max === 0 ? 10 : Math.ceil(max * 1.2);
                    },
                    tickAmount: 4,
                  },
                  grid: {
                    padding: { left: 0, right: 0 }
                  }
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>DA Quality Distribution</Typography>
              <Chart
                type="bar"
                height={240}
                series={[{
                  name: "DA",
                  data: Object.values(summaryData.da_quality_distribution) || []
                }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      columnWidth: '45%',
                      borderRadius: 4,
                      distributed: true, // 👈 IMPORTANT
                      dataLabels: { position: 'top' }
                    }
                  },
                  colors: ["#3f51b5", "#d97757", "#00C9A7", "#FF4D4F", '#ae36ee', '#c9d429'], // 👈 each bar gets color
                  dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: { fontSize: '12px' }
                  },
                  xaxis: {
                    categories: Object.keys(summaryData.da_quality_distribution) || [],
                    position: 'bottom',
                    labels: {
                      offsetX: 50,
                      style: { fontSize: '11px' }
                    }
                  },
                  yaxis: {
                    title: { text: 'Count' },
                    labels: { formatter: (val) => Math.floor(val) }
                  },
                  noData: { text: "No Metric Data Available" }
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Top 5 Most Influential</Typography>
              <Chart
                type="bar"
                height={200}
                series={[{ name: "DA", data: summaryData?.top_5_most_influential.map(i => i.da) }]}
                options={{
                  chart: { toolbar: { show: false } },
                  plotOptions: { bar: { horizontal: true, barHeight: '30%', borderRadius: 4 } },
                  colors: ["#2e7d32"],
                  xaxis: { categories: summaryData?.top_5_most_influential.map(i => i.domain_name), labels: { show: false } },
                  dataLabels: { enabled: true, formatter: (val) => `${val}%`, position: 'right' },
                  tooltip: {
                    custom: ({ dataPointIndex }) => {
                      const item = summaryData?.top_5_critical[dataPointIndex];
                      return `
          <div style="padding:8px 10px;">
            <strong>${item.domain_name}</strong><br/>
            DA: ${item.da}<br/>
          </div>
        `;
                    },
                  },
                }}
              />
            </Box>
          </Grid>

        </Grid>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 200]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <div >
        {/* <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={2}
          columnFreezeWidth={[0, 200]}
          tableLoading={tableLoading}
        /> */}

        {!openCommonAlerts &&
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        }
        <UserActivityTracker pagename="Backlinks - Linked Domains" />
      </div>
    </div>
  );
}
